import styled from 'styled-components';

import { Spacer } from '@zillow/constellation';

export const StyledSpacer = styled(Spacer)<{ checked?: boolean }>`
  ${({ checked }) =>
    checked &&
    `
    background: #fafafa;
  `};
`;
